import styled from 'styled-components';

export const Image = styled.img`
	height: 16px;
	width: 16px;
`;
